export default __webpack_public_path__ + "static/media/up.87130ee6.svg";